export default "__VITE_ASSET__3c910dba__"